var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07758 1V4M14.0298 1V4M1.60444 8.09H18.503M19 7.5V16C19 19 17.509 21 14.0298 21H6.07758C2.59847 21 1.10742 19 1.10742 16V7.5C1.10742 4.5 2.59847 2.5 6.07758 2.5H14.0298C17.509 2.5 19 4.5 19 7.5Z",
    stroke: "#2980B9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7279 12.7002H13.7369M13.7279 15.7002H13.7369M10.05 12.7002H10.0599M10.05 15.7002H10.0599M6.37109 12.7002H6.38103M6.37109 15.7002H6.38103",
    stroke: "#2980B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.96b80fb9b7959c19a29b68bf7561c57d.svg";
export { ForwardRef as ReactComponent };